export default __webpack_public_path__ + "static/media/r2d2.6ce988c4.png";